import React from "react";

import PaymentModelInformation from "./paymentModelInformation";
import DonationCalculationForm from "./donationCalculationForm";

const FeeStructureDonationForm = ({
  feeStructure,
  paymentModel,
}) => (
  <div className="fees__payment-information-container">
    <PaymentModelInformation
      paymentModel={paymentModel}
    />
    <DonationCalculationForm
      feeStructure={feeStructure}
      paymentModel={paymentModel}
    />
  </div>
);

export default FeeStructureDonationForm;
